import Questionnaires from './questionnaires';

export default Questionnaires;
